<template>
    <o-table
        class="fullwidth-table is-responsive is-responsive-desktop"
        :data="paginatedData"
        :bordered="table.bordered"
        :striped="table.striped"
        :narrowed="table.narrowed"
        :checkable="table.checkable"
        :loading="table.loading"
        :mobile-cards="table.mobileCards"
        :paginated="table.paginated"
        :per-page="table.perPage"
        :pagination-simple="table.paginationSimple"
        default-sort="id"
        :selected.sync="selected"
        :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"

        @page-change="onPageChange"
        @sort="onSort"

        backend-pagination
        backend-sorting
        :total="total"
    >

        <template>

            <o-table-column #default="{ row }" field="name" label="Name" sortable>
                {{ row.name }}
            </o-table-column>

            <o-table-column #default="{ row }" field="completion_date" label="Est. Completion Date" sortable>
                {{ $filters.valueOrDefault($filters.date(row.completion_date)) }}
            </o-table-column>

            <o-table-column #default="{ row }" field="id" label="Project #" sortable>
                {{ row.id }}
            </o-table-column>

            <o-table-column #default="{ row }" field="bin" label="House Number" sortable>
                {{ row.bin }}
            </o-table-column>

            <o-table-column #default="{ row }" field="street" label="Street" sortable>
                {{ row.street }}
            </o-table-column>

            <o-table-column #default="{ row }" field="borough" label="Borough" sortable>
                {{ boroughNameById(row.borough) }}
            </o-table-column>

            <o-table-column #default="{ row }" field="status" label="Status" sortable>
                {{ projectStatusById(row.status) }}
            </o-table-column>

            <o-table-column #default="{ row }" label="">
                <o-dropdown hoverable position="bottom-left" class="table-actions">
                  <template #trigger>
                    <button class="button">
                      <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                    </button>
                  </template>

                    <o-dropdown-item has-link>
                        <router-link :to="{ name: 'projects.show', params: { slug: row.id } }">View</router-link>
                    </o-dropdown-item>
                </o-dropdown>
            </o-table-column>

        </template>

        <template #empty>
            <div class="has-text-centered">
                <p>No projects found.</p>
            </div>
        </template>
    </o-table>
</template>

<script>
    import Table from '../../../mixins/Table'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        mixins: [Table],

        props: ['userId'],

        data () {
            return {
                moment: window.moment,
                filters: {
                    assigned_to: this.userId
                }
            }
        },

        mounted () {
            this.fetchPaginatedData()
        },

        methods: {
            ...mapActions({
                fetchData: 'fetchProjects'
            })
        },

        computed: {
            ...mapGetters(['boroughNameById', 'projectStatusById']),

            ...mapGetters({
                itemsByIds: 'projectsByIds'
            })
        }
    }
</script>
